import Box from '@mui/material/Box'
import EstimateLandSummaryHeader from './LandSummaryHeader'
import GeneralInformation from './GeneralInformation'
import AffectationZone from './AffectationZone'
import Restrictions from './Restrictions'
import DeveloppementPotentiel from './DeveloppementPotentiel'

const Land = ({ land, editedLand }: { land: any; editedLand: any }) => {
  return (
    <Box p={1}>
      <EstimateLandSummaryHeader data={land} />
      {editedLand?.landGeneralInformation !== false && (
        <GeneralInformation data={land} editedLand={editedLand} />
      )}
      {editedLand?.landDevelopmentPotential !== false && (
        <DeveloppementPotentiel data={land} />
      )}
      {editedLand?.landAffectationZone !== false && (
        <AffectationZone data={land} />
      )}
      {editedLand?.landRestrictions !== false && <Restrictions data={land} />}
    </Box>
  )
}

export default Land
